// extracted by css-extract-rspack-plugin
export default {"searchLoading":"searchLoading-jXkgiL","branchLabelRow":"branchLabelRow-_ab48d"};